import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Queries, Mutations } from "../../../../../../graphql";
import PropTypes from "prop-types";
import { Typography, Row, Col, Form } from "antd";
import FromInput from "../../../../../../components/user/from/Input";

const { Text, Title } = Typography;
class WelfareListPaymentVictimInPersonnelInformation extends Component {
  state = {
    loading: false,
    loadingFullpage: true,
  };

  async componentDidMount() {}

  render() {
    const { match, rawData } = this.props;
    const { loadingFullpage } = this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <>
        <Row
          gutter={16}
          type="flex"
          justify="left"
          align="top"
          className="py-2"
        >
          <Col md={24} className="mb-3">
            <Text className="color-red" style={{ fontSize: "18px" }}>ข้อมูลบุคลากร</Text>
          </Col>

          <Col md={12} className="mb-2">
            <FromInput
              disabled={true}
              value={rawData? rawData.empTitle+''+rawData.empFirstName+' '+rawData.empLastName : "-" }
              required={true}
              name={"name"}
              label="ชื่อบุคลากร"
              mode={"text"}
            />
          </Col>

          <Col md={12} className="mb-2">
            <FromInput
              disabled={true}
              value={rawData?.positionName ? rawData?.positionName : "-" }
              required={true}
              name={"positionName"}
              label="ตำแหน่ง"
              mode={"text"}
            />
          </Col>

          <Col md={12} className="mb-2">
            <FromInput
              disabled={true}
              value={rawData?.employeeTypeName ? rawData?.employeeTypeName : "-" }
              required={true}
              name={"employeeTypeName"}
              label="ประเภทบุคลากร"
              mode={"text"}
            />
          </Col>

          <Col md={12} className="mb-2">
            <FromInput
              disabled={true}
              value={rawData?.employeeLevelName ? rawData?.employeeLevelName : "-" }
              required={true}
              name={"employeeLevelName"}
              label="ระดับ"
              mode={"text"}
            />
          </Col>

          <Col md={12} className="mb-2">
            <FromInput
              disabled={true}
              value={rawData?.orgName ? rawData?.orgName : "-" }
              required={true}
              name={"orgName"}
              label="สำนัก"
              mode={"text"}
            />
          </Col>

          <Col md={12} className="mb-2">
            <FromInput
              disabled={true}
              value={rawData?.deptName ? rawData?.deptName : "-" }
              required={true}
              name={"deptName"}
              label="หน่วยงาน"
              mode={"text"}
            />
          </Col>

          <Col md={12} className="mb-2">
            <FromInput
              disabled={true}
              value={rawData?.diviName ? rawData?.diviName : "-" }
              required={true}
              name={"diviName"}
              label="ฝ่าย"
              mode={"text"}
            />
          </Col>

          
        </Row>
      </>
    );
  }
}

WelfareListPaymentVictimInPersonnelInformation.defaultProps = {
  autoFocus: false,
};

WelfareListPaymentVictimInPersonnelInformation.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedWelfareListPaymentVictimInPersonnelInformation = Form.create()(
  WelfareListPaymentVictimInPersonnelInformation
);

export default withApollo(
  WrappedWelfareListPaymentVictimInPersonnelInformation
);
